import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
  EAuthActions,
  GetRoles,
  GetRolesFailure,
  GetRolesSuccess
} from '../actions/auth.actions';
import { AuthService } from '@eview/core/auth';
import { Store } from '@ngrx/store';
import { AppState } from '../states/app.state';
import { selectRolesLoaded } from '../selectors/catalog.selectors';

@Injectable()
export class RolesEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store<AppState>);
  private readonly authService = inject(AuthService);

  get$ = createEffect(() =>
    this.actions$.pipe(
      ofType<GetRoles>(EAuthActions.GetRoles),
      withLatestFrom(this.store.select(selectRolesLoaded)),
      filter(([action, loaded]) => action.force || !loaded),
      switchMap(() =>
        this.authService.roles().pipe(
          map(payload => new GetRolesSuccess(payload)),
          catchError(() => of(new GetRolesFailure()))
        )
      )
    )
  );
}
